module.exports = __webpack_public_path__ + "assets/Retina-Thin.99f7a068113b872adcd55c675438cc83.woff";